function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var enc = new TextEncoder();
var dec = new TextDecoder();
var CRC_TABLE = function () {
  var table = new Uint32Array(256);
  for (var i = 0; i < 256; i += 1) {
    var crc = i;
    for (var bit = 0; bit < 8; bit += 1) {
      crc = crc & 1 ? crc >>> 1 ^ 0xedb88320 : crc >>> 1;
    }
    table[i] = crc >>> 0;
  }
  return table;
}();
function crc32(bytes) {
  var crc = 0xffffffff;
  for (var i = 0; i < bytes.length; i += 1) {
    crc = CRC_TABLE[(crc ^ bytes[i]) & 0xff] ^ crc >>> 8;
  }
  return (crc ^ 0xffffffff) >>> 0;
}
function u16(value) {
  var out = new Uint8Array(2);
  out[0] = value & 0xff;
  out[1] = value >>> 8 & 0xff;
  return out;
}
function u32(value) {
  var out = new Uint8Array(4);
  out[0] = value & 0xff;
  out[1] = value >>> 8 & 0xff;
  out[2] = value >>> 16 & 0xff;
  out[3] = value >>> 24 & 0xff;
  return out;
}
function concat(parts) {
  var total = parts.reduce(function (sum, part) {
    return sum + part.length;
  }, 0);
  var out = new Uint8Array(total);
  var offset = 0;
  parts.forEach(function (part) {
    out.set(part, offset);
    offset += part.length;
  });
  return out;
}
function createZip(files) {
  var locals = [];
  var centrals = [];
  var offset = 0;
  (files || []).forEach(function (file) {
    var name = String(file.name || '').replace(/^\/+/, '');
    var data = file.data instanceof Uint8Array ? file.data : new Uint8Array(file.data || []);
    var nameBytes = enc.encode(name);
    var crc = crc32(data);
    var local = concat([u32(0x04034b50), u16(20), u16(0), u16(0), u16(0), u16(0), u32(crc), u32(data.length), u32(data.length), u16(nameBytes.length), u16(0), nameBytes, data]);
    var central = concat([u32(0x02014b50), u16(20), u16(20), u16(0), u16(0), u16(0), u16(0), u32(crc), u32(data.length), u32(data.length), u16(nameBytes.length), u16(0), u16(0), u16(0), u16(0), u32(0), u32(offset), nameBytes]);
    locals.push(local);
    centrals.push(central);
    offset += local.length;
  });
  var centralStart = offset;
  var centralSize = centrals.reduce(function (sum, part) {
    return sum + part.length;
  }, 0);
  var end = concat([u32(0x06054b50), u16(0), u16(0), u16(files.length), u16(files.length), u32(centralSize), u32(centralStart), u16(0)]);
  return concat([].concat(locals, centrals, [end]));
}
function readU16(bytes, offset) {
  return bytes[offset] | bytes[offset + 1] << 8;
}
function readU32(bytes, offset) {
  return (bytes[offset] | bytes[offset + 1] << 8 | bytes[offset + 2] << 16 | bytes[offset + 3] << 24) >>> 0;
}
function findEndOfCentralDirectory(bytes) {
  for (var i = bytes.length - 22; i >= 0; i -= 1) {
    if (readU32(bytes, i) === 0x06054b50) {
      return i;
    }
  }
  return -1;
}
function inflateRaw(_x) {
  return _inflateRaw.apply(this, arguments);
}
function _inflateRaw() {
  _inflateRaw = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(bytes) {
    var stream, _t, _t2;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!(typeof DecompressionStream !== 'function')) {
            _context.n = 1;
            break;
          }
          throw new Error('Compressed ZIP entries are not supported in this browser.');
        case 1:
          stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('deflate-raw'));
          _t = Uint8Array;
          _context.n = 2;
          return new Response(stream).arrayBuffer();
        case 2:
          _t2 = _context.v;
          return _context.a(2, new _t(_t2));
      }
    }, _callee);
  }));
  return _inflateRaw.apply(this, arguments);
}
function readZip(_x2) {
  return _readZip.apply(this, arguments);
}
function _readZip() {
  _readZip = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(bytes) {
    var source, end, count, cursor, entries, i, method, compressedSize, nameLength, extraLength, commentLength, localOffset, name, localNameLength, localExtraLength, dataStart, compressed, data;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          source = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes || []);
          end = findEndOfCentralDirectory(source);
          if (!(end < 0)) {
            _context2.n = 1;
            break;
          }
          throw new Error('That ZIP archive could not be read.');
        case 1:
          count = readU16(source, end + 8);
          cursor = readU32(source, end + 16);
          entries = [];
          i = 0;
        case 2:
          if (!(i < count)) {
            _context2.n = 9;
            break;
          }
          if (!(readU32(source, cursor) !== 0x02014b50)) {
            _context2.n = 3;
            break;
          }
          throw new Error('That ZIP archive could not be read.');
        case 3:
          method = readU16(source, cursor + 10);
          compressedSize = readU32(source, cursor + 20);
          nameLength = readU16(source, cursor + 28);
          extraLength = readU16(source, cursor + 30);
          commentLength = readU16(source, cursor + 32);
          localOffset = readU32(source, cursor + 42);
          name = dec.decode(source.subarray(cursor + 46, cursor + 46 + nameLength));
          cursor += 46 + nameLength + extraLength + commentLength;
          if (!(readU32(source, localOffset) !== 0x04034b50)) {
            _context2.n = 4;
            break;
          }
          throw new Error('That ZIP archive could not be read.');
        case 4:
          localNameLength = readU16(source, localOffset + 26);
          localExtraLength = readU16(source, localOffset + 28);
          dataStart = localOffset + 30 + localNameLength + localExtraLength;
          compressed = source.subarray(dataStart, dataStart + compressedSize);
          data = compressed;
          if (!(method === 8)) {
            _context2.n = 6;
            break;
          }
          _context2.n = 5;
          return inflateRaw(compressed);
        case 5:
          data = _context2.v;
          _context2.n = 7;
          break;
        case 6:
          if (!(method !== 0)) {
            _context2.n = 7;
            break;
          }
          throw new Error('That ZIP archive uses an unsupported compression method.');
        case 7:
          if (!name.endsWith('/')) {
            entries.push({
              name: name,
              data: data
            });
          }
        case 8:
          i += 1;
          _context2.n = 2;
          break;
        case 9:
          return _context2.a(2, entries);
      }
    }, _callee2);
  }));
  return _readZip.apply(this, arguments);
}
function looksLikeZip(bytes) {
  var source = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes || []);
  return source.length >= 4 && source[0] === 0x50 && source[1] === 0x4b && (source[2] === 0x03 || source[2] === 0x05 || source[2] === 0x07);
}
function isZipFile(file) {
  var name = String((file === null || file === void 0 ? void 0 : file.name) || '').toLowerCase();
  var type = String((file === null || file === void 0 ? void 0 : file.type) || '').toLowerCase();
  return name.endsWith('.zip') || type === 'application/zip' || type === 'application/x-zip-compressed';
}
module.exports = {
  createZip: createZip,
  readZip: readZip,
  looksLikeZip: looksLikeZip,
  isZipFile: isZipFile
};